import React from "react";

function EmptyWidgetComponent() {
  return <div>EmptyWidgetComponent</div>;
}

export default EmptyWidgetComponent;
